/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentAuthor = zod.object({
  principalType: zod
    .enum(['USER', 'GROUP', 'GROUP_MEMBER', 'AGENT'])
    .describe(
      'USER: a person, as themselves. GROUP: a group acting as itself. GROUP_MEMBER: a person as a member of the group in scopeUuid. AGENT: an agent — with scopeUuid, writing for that user under their delegation.',
    ),
  principalUuid: zod
    .uuid()
    .describe('The author: a user, group or agent actor (a GROUP_MEMBER is the user).'),
  roles: zod
    .array(zod.enum(['AUTHOR', 'ON_BEHALF_OF']))
    .describe(
      'AUTHOR: wrote some version of this content or of something it contains. ON_BEHALF_OF: an agent that wrote for the user in scopeUuid, under their delegation. Only what is recorded — nothing is inferred.',
    ),
  scopeUuid: zod
    .uuid()
    .nullable()
    .describe(
      'The group a GROUP_MEMBER wrote as a member of, or the user an AGENT wrote for. Null otherwise.',
    ),
});

export type ContentAuthor = zod.input<typeof ContentAuthor>;
export type ContentAuthorOutput = zod.output<typeof ContentAuthor>;
